import {
  Form,
  TextInput,
  TextAreaInput,
  CheckboxInput,
} from '../components/form/index.js';
//import { emit } from '../../util/helpers.js';

const TenantInputs = [
  new TextInput({
    type: 'text',
    label: 'Name',
    id: 'inputName',
    required: true,
    autofocus: true,
  }),
  new CheckboxInput({
    label: '508 Compliant',
    id: 'InputIs508',
  }),
  new CheckboxInput({
    label: 'Requires Copyright Acknowledgement',
    id: 'inputRequiresCopyrightAcknowledgement',
  }),
  new TextAreaInput({
    type: 'text',
    label: 'Copyright Statement',
    id: 'inputCopyrightStatement',
    classes: 'bottom',
  }),
];

const TenantForm = new Form({
  inputs: TenantInputs,
  id: 'tenant-form',
  title: 'Create/Edit Tenant',
});

export { TenantForm };
